import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/home'
import Configuration from '@/components/configuration/configuration'
import Trace from '@/components/shared/trace/trace'
import Product from '@/components/product/product'
import Cart from '@/components/cart/cart'
import Account from '@/components/account/account'
import Storefront from '@/components/configuration/storefront/storefront'
import Checkout from '@/components/configuration/checkout/checkout'
import Callback from '@/components/configuration/callback/callback'
import FederatedID from '@/components/configuration/federatedID/federatedID'
import Advanced from '@/components/configuration/advanced/advanced'
import Tokenization from '@/components/configuration/tokenization/tokenization'
import Dashboard from '@/components/home/dashboard/dashboard.vue'
import Review from '@/components/review/review.vue'
import AuthReview from '@/components/auth-review/auth-review.vue'
import Confirm from '@/components/confirm/confirm.vue'
import ProductListing from '@/components/home/product-listing/product-listing'
import Vsrci from '@/components/vsrci/vsrci'
import TestToolsHome from '@/components/test-tools-home/test-tools-home'
import ConsumerResetPassword from '@/components/account/consumer-reset-password/consumer-reset-password'
import PageNotFoundComponent from '@/components/shared/page-not-found/page-not-found'
import Auth from '@/components/configuration/auth/auth'
import TavReview from '@/components/tav-review/tav-review.vue'
import PaymentCallbackScreen from '@/components/payment-callback-screen/payment-callback-screen'

Vue.use(Router)

const originalPush = Router.prototype.push
const { isNavigationFailure, NavigationFailureType } = Router
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch((error) => {
    if (!isNavigationFailure(error, NavigationFailureType.duplicated)) {
      throw Error(error)
    }
  })
}

export default new Router({
  mode: 'history',
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: Home,
    children: [{
      path: '/configuration',
      name: 'Configuration',
      component: Configuration,
      children: [{
        path: '/configuration/menu',
        name: 'Menu',
        component: Checkout
      },
      {
        path: '/configuration/storefront',
        name: 'Storefront',
        component: Storefront
      },
      {
        path: '/configuration/checkout',
        name: 'Checkout',
        component: Checkout
      },
      {
        path: '/configuration/tokenization',
        name: 'Tokenization',
        component: Tokenization
      },
      {
        path: '/configuration/callback',
        name: 'Callback',
        component: Callback
      },
      {
        path: '/configuration/advanced',
        name: 'Advanced',
        component: Advanced
      },
      {
        path: '/configuration/federatedid',
        name: 'FederatedID',
        component: FederatedID
      },
      {
        path: '/configuration/auth',
        name: 'Auth',
        component: Auth
      }
      ]
    },
    {
      path: '/',
      name: 'Default',
      component: Dashboard
    },
    {
      path: '/trace',
      name: 'Trace',
      component: Trace
    },
    {
      path: '/product/:productId',
      name: 'Product',
      component: Product
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/reset/:token',
      name: 'ConsumerResetPassword',
      component: ConsumerResetPassword
    },
    {
      path: '/all-products',
      name: 'ProductListing',
      component: ProductListing
    },
    {
      path: '/review',
      name: 'Review',
      component: Review
    },
    {
      path: '/confirm',
      name: 'Confirm',
      component: Confirm
    },
    {
      path: '/authreview',
      name: 'authreview',
      component: AuthReview
    },
    {
      path: '/tavreview',
      name: 'tavreview',
      component: TavReview
    }
    ]
  },
  {
    path: '/auth-process',
    name: 'PaymentCallbackScreen',
    component: PaymentCallbackScreen
  },
  {
    path: '/vsrci',
    name: 'vsrci',
    component: Vsrci
  },
  {
    path: '/testingtools',
    name: 'testingtools',
    component: TestToolsHome
  },
  { path: '/:catchAll(.*)', component: PageNotFoundComponent }
  ]
}
)
